export function unregister(callback) {
  if ("serviceWorker" in navigator) {
    console.log("unregister service worker");
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        if (callback) {
          callback();
        }
      })
      .catch((error) => {
        console.error(error.message);
        if (callback) {
          callback();
        }
      });
  } else {
    if (callback) {
      callback();
    }
  }
}
